import { render, staticRenderFns } from "./ListSectionComponents.vue?vue&type=template&id=620b6ef7&scoped=true&"
import script from "./ListSectionComponents.vue?vue&type=script&lang=js&"
export * from "./ListSectionComponents.vue?vue&type=script&lang=js&"
import style0 from "./ListSectionComponents.vue?vue&type=style&index=0&id=620b6ef7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b6ef7",
  null
  
)

export default component.exports